import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import { Config } from '@shared/config';
import localeDe from '@angular/common/locales/de';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';
import { StorageService } from '@shared/services/storage.service';

registerLocaleData(localeDe, 'de');
registerLocaleData(localePl, 'pl');
registerLocaleData(localeEn, 'en');

@Pipe({
  name: 'currencyAmount',
})
export class CurrencyAmountPipe implements PipeTransform {
  cp: CurrencyPipe = new CurrencyPipe('en-US');

  constructor(public storage: StorageService) {}

  transform(value: any, currency: string = Config.CURRENCY_TEXT): string {
    const currentLocale = currency === 'USD' ? null : 'pl';
    let result = null;
    if (value !== null) {
      result = this.cp.transform(value / 100, currency, 'symbol', null, currentLocale);
    } else {
      result = this.cp.transform(0, currency, 'symbol', null, currentLocale).split('0')[0];
    }
    return result.replace(' ', '');
  }
}
